import { filter, find, includes, isEmpty, propEq } from 'ramda';
import store from '../../redux/Store';
import '../../i18n';
import { getTranslation } from '../../Components/Graphs/sensor-utils';

const regex = /\(.*\)/;

const checkProjectName = (projectName: string, projectId: string) => {
  const getProjects = () => {
    const state = store.getState();
    const { projects } = state.project;
    return projects;
  };

  let _projects = getProjects();
  if (projectId) {
    _projects = filter((p) => p.id !== projectId, _projects);
  }

  const getDefaultProgramName = () => {
    const untitledProgram = getTranslation('projectDialog.untitled_project', 'Untitled Project');
    return untitledProgram;
  };

  const checkProgramNameNumber = (count: number, testName: string) => {
    const testTitle = `${testName} (${count})`;
    const found = find(propEq(testTitle, 'name'), _projects);
    if (found) return checkProgramNameNumber(count + 1, testName);
    return testTitle;
  };

  const findMatch = (title: string, count: number) => {
    let _count = count;
    let testName = projectName;
    if (isEmpty(testName)) testName = getDefaultProgramName();
    const match = title.match(regex);
    let oldTitle = title;
    if (match) {
      oldTitle = title.replace(regex, '');
    }
    if (oldTitle.trim() === testName.trim()) _count += 1;
    return _count;
  };

  /**
   * Checks the name of a program to make sure it doesn't match the name of an existing program
   * the user already has. Most common scenario is the user never names programs so they have a bunch of
   * Untitled Programs.
   * @param {*array} data an array of programs for the user
   * @param {*string} programName the name of the program.
   * @returns
   */
  const checkTitle = () => {
    let count = 0;
    let testName = projectName.trim();
    if (isEmpty(testName)) testName = getDefaultProgramName();
    const containsName = filter((project) => includes(testName, project.name), _projects);
    if (containsName.length > 0) {
      // first look for exact matches
      containsName.forEach((project) => {
        if (project.name === testName && project.name.match(regex)) testName = `${testName} (1)`;
      });
      containsName.forEach((project) => {
        if (project.name) {
          count = findMatch(project.name, count);
        } else {
          const title = getDefaultProgramName();
          count = findMatch(title, count);
        }
      });
      if (count === 0) return testName;
      const checkedName = checkProgramNameNumber(count, testName);
      return checkedName;
    }
    return testName;
  };

  return checkTitle();
};

export default checkProjectName;
